<template>
    <div id="permit_type_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                        <span class="page-title" id="vehiclePermitTypeHeader" v-if="$route.params.id > 0">Update Asset Permit</span>
                        <span class="page-title" id="vehiclePermitTypeHeader" v-else>Add Asset Permit</span>
                        <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackVehiclePermitTypesList" >
                               <i class="fp-back"> </i> Back
                        </button>
                    </div>
                <div class="container-fluid">
                    <div class="admin-page-content verhicle-permit-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="vehiclePermitTypeForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="vehicle_id">Asset:</label>
                                        <v-select v-model="vehicle_id" name="vehicle_id"
                                            label="text" :filterable="false" :options="vehicleArr"
                                            @search="onSearchVehicle"
                                            placeholder="Select Asset" class="custom-ci-auto-search" :disabled="disableUnitField">
                                            <template slot="no-options">
                                                Search Asset...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ vehicle_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="description">Permit Number:</label>
                                        <input type="text" class="form-control" v-model="per_number" id="Permit" placeholder="Permit Number" name="Permit" @keypress="inputUpperCase($event)" :disabled="disablePermitField" @blur="checkPermitNumber">
                                        <div class="field-error">{{per_number_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="state">State:</label>
                                        <v-select v-model="state" name="state"
                                            label="text" :filterable="false" :options="stateArr"
                                            @search="onSearchState"
                                            placeholder="Search State" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Location...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{state_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="vehicle_id">Permit Type:</label>
                                        <v-select v-model="permit_type" name="vehicle_id"
                                            label="text" :options="permitArr"
                                            placeholder="Select Permit Type" class="custom-ci-auto-search">
                                        </v-select>
                                        <div class="field-error">{{ permit_type_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require">Effective Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" @dp-change="onStartChange" id="effective_date" name="effective_date" v-model="effective_date" :config="optionsDate" aria-describedby="basic-addon3" class="cal-icon" :disabled="disableFields"></date-picker>
                                            <label for="effective_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{effective_date_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require">Expiry Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="expiry_date" name="expiry_date" v-model="expiry_date" :config="toOptionsDate" aria-describedby="basic-addon3" class="cal-icon" :disabled="disableFields"></date-picker>
                                            <label for="expiry_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{expiry_date_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="location">Location:</label>
                                        <v-select v-model="location_id" name="location"
                                            label="text" :filterable="true" :options="locationArr" placeholder="Select Location">
                                        </v-select>
                                        <div class="field-error">{{location_error_msg}}</div>
                                    </div>
                                    <div class="clear-both"></div>
                                    <div class="col-md-2 form-group">
                                        <label class="control-label" for="ifta">IFTA:</label>
                                        <input type="text" class="form-control" v-model="ifta" id="ifta" placeholder="Enter IFTA" name="ifta" @keypress="validateAmount($event)" @input="calculatePermitAmount($event)" :disabled="disableFields">
                                        <div class="field-error">{{ifta_error_msg}}</div>
                                    </div>
                                    <div class="col-md-2 form-group">
                                        <label class="control-label" for="nm">NM:</label>
                                        <input type="text" class="form-control" v-model="nm" id="nm" placeholder="Enter NM" name="nm" @keypress="validateAmount($event)" @input="calculatePermitAmount($event)" :disabled="disableFields">
                                        <div class="field-error">{{nm_error_msg}}</div>
                                    </div>
                                    <div class="col-md-2 form-group">
                                        <label class="control-label" for="irp">IRP:</label>
                                        <input type="text" class="form-control" v-model="irp" id="irp" placeholder="Enter IRP" name="irp" @keypress="validateAmount($event)" @input="calculatePermitAmount($event)" :disabled="disableFields">
                                        <div class="field-error">{{irp_error_msg}}</div>
                                    </div>
                                    <div class="col-md-2 form-group">
                                        <label class="control-label" for="pyr">PFR:</label>
                                        <input type="text" class="form-control" v-model="pyr" id="pyr" placeholder="Enter PFR" name="pyr" @keypress="validateAmount($event)" @input="calculatePermitAmount($event)" :disabled="disableFields">
                                        <div class="field-error">{{pyr_error_msg}}</div>
                                    </div>
                                    <div class="col-md-2 form-group">
                                        <label class="control-label" for="title_fee">Title Fee:</label>
                                        <input type="text" class="form-control" v-model="title_fee" id="title_fee" placeholder="Enter Title fee" name="title_fee" @keypress="validateAmount($event)" @input="calculatePermitAmount($event)" :disabled="disableFields">
                                        <div class="field-error">{{title_error_msg}}</div>
                                    </div>
                                    <div class="col-md-2 form-group">
                                        <label class="control-label require" for="description">Amount:</label>
                                        <input type="text" class="form-control"
                                        v-model="amount"
                                        @focus="amount = enterVal($event)"
                                        @blur="amount = leaveFocus($event)"
                                        @input="validateInput"
                                        id="Amount" placeholder="Enter Amount" name="amount" :disabled="disableFields" @keypress="validateAmount($event)">
                                        <div class="field-error">{{amount_error_msg}}</div>
                                    </div>
                                    <div class="col-md-6 form-group">
                                        <label class="control-label" for="description">Description:</label>
                                        <input type="text" class="form-control" v-model="description" id="description" placeholder="Enter Description" name="description">
                                        <div class="field-error">{{description_error_msg}}</div>
                                    </div>


                                    <div class="col form-group">
                                        <label class="control-label" for="vehicle_id">Licence Type:</label>
                                        <v-select v-model="licence_type" name="vehicle_id"
                                            label="text" :options="licenceArr"
                                            placeholder="Select Permit Type" class="custom-ci-auto-search">
                                        </v-select>
                                        <div class="field-error">{{ licence_type_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="vehicle_id">Reportable:</label>
                                        <v-select v-model="reportable" name="owner"
                                            label="text" :options="reportArr"
                                            placeholder="Reportable" class="custom-ci-auto-search">
                                        </v-select>
                                        <div class="field-error">{{ report_error_msg }}</div>
                                    </div>
                                    <div v-if="$route.params.id > 0" class="col form-group">
                                        <label class="control-label">Cancel Date</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="cancel_date" name="cancel_date" v-model="cancel_date" :config="CanceloptionsDate" aria-describedby="basic-addon3" class="cal-icon" :disabled="disableCancelDate"></date-picker>
                                            <label for="cancel_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{cancel_date_error_msg}}</div>
                                    </div>
                                    <div class="col form-group" v-if="customer_id != null && customerFound">
                                        <label class="control-label" for="old_permit_amount">Customer:&nbsp;&nbsp;</label><br/>
                                        <span class="label">{{customer_id.text}}</span>
                                    </div>
                                    <div class="col form-group" v-if="customer_id != null && customerFound">
                                        <label class="control-label" for="allowance">Allowance:&nbsp;&nbsp;</label><br/>
                                        <span class="label">${{allowance.toFixed(2)}}</span>
                                    </div>
                                    <!-- <div class="col form-group">
                                        <label class="control-label require" for="vehicle_id">Owner:</label>
                                        <v-select v-model="owner" name="owner"
                                            label="text" :options="ownerArr"
                                            placeholder="Select Owner" class="custom-ci-auto-search close-remove">
                                        </v-select>
                                        <div class="field-error">{{ owner_error_msg }}</div>
                                    </div> -->
                                    <div class="col form-group" v-if="showCustomerField">
                                        <label class="control-label" for="added_customer">Customer:</label>
                                        <v-select v-model="added_customer" name="added_customer" id="added_customer" label="text" :filterable="false" :options="customerArr" @search="onSearchCustomer" placeholder="Select Customer" class='custom-ci-auto-search'>
                                            <template slot="no-options">
                                                Search Customer...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{added_customer_error_msg}}</div>
                                    </div>
                                </div>
                                <div class="field-error">{{common_error_msg}}</div>
                                <template v-if="detailFound">
                                    <div class="field-error"> {{permitMessage}} </div>
                                    <div class="field-error"> {{permitNoMessage}}</div>
                                    <div class="list-view">
                                        <div class="form-row">
                                            <div class="col-md-6">
                                                <div class="row form-group">
                                                    <label class="col">Permit Number :</label>
                                                    <span class="col" v-fp-html="permitReference"></span>
                                                </div>
                                                <div class="row form-group">
                                                    <label class="col">Effective Date :</label>
                                                    <span class="col">{{effectiveDate}}</span>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="row form-group">
                                                    <label class="col">Permit Type :</label>
                                                    <span class="col">{{permitTypeDesc}}</span>
                                                </div>
                                                <div class="row form-group">
                                                    <label class="col">Expiry Date :</label>
                                                    <span class="col">{{expiryDate}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createVehiclePermitBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateVehiclePermit" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>

                                    <button type="submit" id="createVehiclePermitBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateVehiclePermit" >
                                    <i class="fp-save"> </i>  Save
                                    </button>

                                    <button type="submit" id="createAndContinueVehiclePermitTypeBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateVehiclePermit(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>

                                    <button type="submit" id="cancelPermitTypeBtn" class="btn btn-tertiary" v-on:click.prevent="BackVehiclePermitTypesList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>

                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

import {contractMixins} from '../mixins/contractMixins';
import moment from 'moment';


export default {
  name: "VehiclePermitTypesCreate",
  metaInfo() {
    return {
        title: (this.$route.params.id > 0)? "Update Asset Permit | " +process.env.COPYRIGHT_NAME : "Create Asset Permit | " +process.env.COPYRIGHT_NAME
    }
  },
  
  mixins:[commonMixins,contractMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    name: "",
    description: "",
    state: null,
    CanceloptionsDate: {
        format: 'MM/DD/YYYY',
        useCurrent: true,
        // maxDate:new Date,
    },
    optionsDate: {
        format: 'MM/DD/YYYY',
        useCurrent: false,
    },
    stateArr: [],
    loading:false,
    name_error_msg: "",
    state_error_msg:"",
    description_error_msg: "",
    vehicleArr:[],
    vehicle_id:null,
    amount:0,
    bill_amount:"",
    effective_date:"",
    expiry_date:"",
    bill_amount_error_msg:"",
    amount_error_msg:"",
    expiry_date_error_msg:"",
    effective_date_error_msg:"",
    per_number_error_msg:"",
    per_number:"",
    vehicle_error_msg:"",
    cancel_date:"",
    cancel_date_error_msg:"",
    customerArr:[],
    customer_id:null,
    permitArr:[{}],
    permit_type:null,
    locationArr:[],
    permit_type_error_msg:"",
    loaded:false,
    unit_no:"",
    licenceArr:[{value:'Full Plated',text:'Full Plated'}
    ,{value:'Prorate',text:'Prorate'}],
    licence_type:null,
    licence_type_error_msg:"",
    owner:null,
    ownerArr:[{value:'Company',text:'Company'},
    {value:'Customer',text:'Customer'}],
    owner_error_msg:"",
    reportArr:[{value:'Yes',text:'Yes'},
    {value:'No',text:'No'}],
    reportable:null,
    report_error_msg:"",
    location_error_msg:'',
    location_id:'',
    disableFields:false,
    showCancellationPrompt:false,
    cancellationAmount:0,
    disableCancelDate:false,
    watchCall:false,
    added_customer:null,
    showCustomerField:false,
    disableCustomerField:false,
    added_customer_error_msg:"",
    customerFound:false,
    detailFound:false,
    permitNoFound:false,
    permitNumber:"",
    effectiveDate:"",
    expiryDate:"",
    permitTypeDesc:"",
    permitReference:"",
    permitMessage:"",
    permitNoMessage:"",
    alreadyExists:false,
    common_error_msg:"",
    ifta:"",
    ifta_error_msg:"",
    nm:"",
    nm_error_msg:"",
    irp:"",
    irp_error_msg:"",
    pyr:"",
    title_fee:"",
    pyr_error_msg:"",
    title_error_msg:"",
    disableAmountField:true,
    allowance:0,
    fromUrl: "",
    from:"",
    disableUnitField:false,
    disablePermitField:false,
    unitPermitFound:false
  }),
  watch: {

        //load location on select vehicle
        vehicle_id: function(veh) {
            //prevent watch call for first time in case of update
            if (this.$route.params.id > 0 && !this.watchCall) {
                return;
            }else{
                if (veh != null && veh != "") {
                    if ( veh.locName != null ) {
                        this.location_id = {text: veh.locName +" | "+ veh.locCode, value:veh.locId}
                    }
                    this.detailFound = false;
                    this.permitNoFound = false;
                    this.alreadyExists = false;
                    this.permitMessage = "";
                    this.permitNoMessage = "";
                    this.permitReference = "";
                    this.fetchUnitPermit();
                }
            }

        },

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_asset_permit') {
                        self.cantAccessPage = true;
                    }
                }
            }

        },

        permit_type: function(newVal,oldVal){
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            if(segments[3]){
                return;
            }

            if (newVal != null) {
                if(newVal.value != undefined){
                    $.ajax({
                        url: process.env.ROOT_API + "/vehiclepermittype/" + newVal.value,
                        type: "GET",
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;
                            if (data.status == "success") {
                                self.description = data.content.description;
                                self.effective_date = data.content.effective_date;
                                // self.expiry_date = data.content.expiry_date;
                                self.amount = self.amountFormat(data.content.amount);
                                if(data.content.license_type == null || data.content.license_type == ""){
                                    self.licence_type = null;
                                }else{
                                    self.licence_type = {value: data.content.license_type, text: data.content.license_type};
                                }

                                if(data.content.reportable == null || data.content.reportable == ""){
                                    self.reportable = null;
                                }else{
                                    self.reportable = {value: data.content.reportable, text: data.content.reportable};
                                }
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,true,'load-vehicle-permit-type')
                        }
                    });
                }
            }
        },

        effective_date: function(val){
            var self = this;
            // auto reflect the expiry date, if permit type contains IRP
            if(self.effective_date != null){
                // split the effective date and get the year,
                // according to effective date year, change the expiry date year.
                /*var getEffectiveYear = self.effective_date.split("/")[2]
                var givenstaticDate = new Date("03/31/"+getEffectiveYear)
                if(self.permit_type != null){

                    if(self.permit_type.text.includes("CALIFORNIA IRP APPORTIONED")){

                        var nextYear = parseInt(getEffectiveYear) + 1;
                        var staticExpiryDate = "";
                        if(new Date(self.effective_date)  >= givenstaticDate){
                             staticExpiryDate = "03/31/" + nextYear;
                        }
                        else{
                             staticExpiryDate = "03/31/" + getEffectiveYear;
                        }
                        self.expiry_date = new Date(staticExpiryDate);
                    }
                    else{
                        self.expiry_date = "";
                    }
                }*/
                //to fix issue of expiry date not populated while update
                if (self.$route.params.id == undefined) {
                    var getEffectiveYear = self.effective_date.split("/")[2]
                    var givenstaticDate = new Date("03/31/"+getEffectiveYear)
                    if(self.permit_type != null){

                        if(self.permit_type.text.includes("CALIFORNIA IRP APPORTIONED")){

                            var nextYear = parseInt(getEffectiveYear) + 1;
                            var staticExpiryDate = "";
                            if(new Date(self.effective_date)  >= givenstaticDate){
                                staticExpiryDate = "03/31/" + nextYear;
                            }
                            else{
                                staticExpiryDate = "03/31/" + getEffectiveYear;
                            }
                            self.expiry_date = new Date(staticExpiryDate);
                        }
                        else{
                            self.expiry_date = "";
                        }
                    }
                }
            }

            /*$.ajax({
                url: process.env.ROOT_API + "/reservation/getCurrentReservation",
                type: "GET",
                headers: this.ajxHeaders,
                crossDomain: true,
                dataType:"json",
                data:{
                    vehicle_id: self.vehicle_id.value,
                    from_date:self.effective_date,
                },
                success: function (data) {
                    self.loading = false;
                    if (data.status == 'success') {
                        // self.showDetailInfo = 'show';
                        if(data.content.custId != undefined){
                            self.customer_id = {value: data.content.custId , text : self.formatString(data.content.custName) + " (" + data.content.custCode + ")"};
                        }

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.Registerbtn = "Register";
                    self.generateStatusCodeMessage(jqXHR,true,'load-permit-effective-date')
                }
            });*/
            if (self.$route.params.id == undefined) {
                if (self.expiry_date != null && self.expiry_date != "") {
                    self.getPermitDetails();
                    return;
                }
            }
        },
        expiry_date: function(val){
            var self = this;
            if (self.$route.params.id == undefined) {
                //to prevent multiple api call if permit found on asset select
                if (self.unitPermitFound) {
                    self.unitPermitFound = false;
                    return;
                }
                self.getPermitDetails();
            }
        },

        cancel_date: function(){
            var self = this;
            //prevent watch call for first time in case of update
            if (self.$route.params.id > 0 && !self.watchCall) {
                return;
            }else{
                self.showCancellationPrompt = false;
                if (!self.customerFound) {
                    if (self.customer_id == null) {
                        if (self.cancel_date != null && self.cancel_date != "") {
                            self.showCustomerField = true;
                        }else{
                            self.showCustomerField = false;
                            self.added_customer = null;
                        }
                    }
                }
            }
        }
  },
  created: function() {

  },
  mounted: function() {
    var self = this;
    self.getPermissions();
    self.getPermitType();
    if(self.$route.query.fromUrl != "" && self.$route.query.fromUrl != undefined){
      self.fromUrl = atob(self.$route.query.fromUrl);
    }
    var path = window.location.pathname;
    var segments = path.split("/");
    self.CanceloptionsDate.maxDate = moment().format("MM/DD/YYYY");

    if (segments[3]) {
        self.loadPermit();
    }
    self.loadFieldData(['location']);

    var webloc = window.location.href;

        var decodeStr = "";

    if ( this.$route.query.data != '' && this.$route.query.data != undefined ) {

        decodeStr = atob(this.$route.query.data)

    }

    var url = new URL(webloc+"?"+decodeStr);
    var assetId = url.searchParams.get("assetId");
     self.from = url.searchParams.get("redirectFrom");

    setTimeout(function () {
        if(self.from == 'assetView'){

            self.getVehicleData(assetId);
        }
    },1000);

  },
  methods: {
    validateInput(evt) {
      var self = this;
      evt = (evt) ? evt : window.event;
      if(evt.target.value > 999999.99) {
        self.amount_error_msg = "Amount value exceed";
      } else {
        self.amount_error_msg = "";
      }
    },
      // enterVal:function(evt) {
      //   evt = (evt) ? evt : window.event;
      //   console.log("ENTER  ==", evt.target.value);
      //   this.amount = evt.target.value;
      //   this.amount = evt.target.value.replace(/\,/g,"");
      // },
      // leaveFocus:function(evt) {
      //   evt = (evt) ? evt : window.event;
      //   console.log("focus ==", evt.target.value);
      //   this.amount =  this.amountFormat(evt.target.value);
      // },
      amountFormat(amount) {
          const formatter = new Intl.NumberFormat('en-US', {
              minimumFractionDigits:2,
              maximumFractionDigits:2
          });

          return formatter.format(amount);
      },

    getVehicleData: function(id){
      var self = this;

      $.ajax({
            url: process.env.ROOT_API + "/asset/"+id,
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    self.vehicle_id = {text:data.content.unit_no+' | '+data.content.vtCode+' | '+data.content.plName,value:data.content.id};
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'get-permit-vehicle-data')
            }
        });
    },

    onSearchVehicle(search, loading) {
        var self = this;
        if (search.length > 3) {
            loading(true);
            self.searchField(loading, search, 'permit_vehicle');
        }

    },
    onSearchState(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'state', '');
        }
    },
    // onSearchLocation(search, loading) {
    //     var self = this;
    //     if (search.length > 2) {

    //         loading(true);
    //         self.searchField(loading, search, 'location', '');
    //     }
    // },
    getPermitType(){
        var self = this;

        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/permit-types/fetch",
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    self.permitArr = data.content;
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'get-permit-type-data')
            }
        });
    },
    loadPermit(){
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/vehiclepermit/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);

                if (data.status == "success") {
                    if(data.content.unit_no){
                        self.loaded = true;
                        self.unit_no = data.content.unit_no;
                    }
                    self.effective_date = data.content.effective_date;
                    self.expiry_date = data.content.expiry_date;
                    self.cancel_date = data.content.cancel_date;
                    self.amount = self.amountFormat(data.content.amount);
                    self.ifta = data.content.ifta;
                    self.nm = data.content.nm;
                    self.irp = data.content.irp;
                    self.pyr = data.content.pyr;
                    self.title_fee = data.content.title_fee;
                    // self.bill_amount = data.content.billback_amount;
                    self.description = data.content.description;
                    self.per_number = data.content.permit_number;
                    //self.disablePermitField = true;
                    if(data.content.vehicle_permit_type_id == null){
                        self.permit_type = null;
                    }else{
                        self.permit_type = {value: data.content.vehicle_permit_type_id, text: data.content.permit_type+' | '+data.content.permitTypeDes+' | '+data.content.stateName};
                    }

                    if(data.content.state_id == null){
                        self.state = null;
                    }else{
                        self.state = {value: data.content.state_id, text: data.content.stateName};
                    }
                    if(data.content.location_id == null){
                        self.location_id = null;
                    }else{
                        self.location_id = {value: data.content.location_id, text: data.content.stName};
                    }

                    if(data.content.custId == null){
                        self.customer_id = null;
                    }else{
                        self.customer_id = {value: data.content.custId, text: data.content.custCode + " | " + data.content.custName};
                    }

                    // if(data.content.vehicle_id == null){
                    //     self.vehicle_id = null;
                    // }else{
                    //     self.vehicle_id = {value: data.content.vehicle_id, text: data.content.unit_no};
                    // }
                    if(data.content.vehicle_id != null){
                        var vehicleData = self.titleCase(data.content.unit_no);
                        if(data.content.vtCode != null){
                            vehicleData += " | " + self.titleCase(data.content.vtCode);
                        }
                        if(data.content.vName != null){
                            vehicleData += " | " + self.titleCase(data.content.vName);
                        }
                        self.vehicle_id = {value: data.content.vehicle_id, text: vehicleData};
                        // self.disableUnitField = true;
                    }else{
                        self.vehicle_id = null;
                    }

                    if(data.content.owner == null || data.content.owner == ""){
                        self.owner = null;
                    }else{
                        self.owner = {value: data.content.owner, text: data.content.owner};
                    }

                    if(data.content.license_type == null || data.content.license_type == ""){
                        self.licence_type = null;
                    }else{
                        self.licence_type = {value: data.content.license_type, text: data.content.license_type};
                    }

                    if(data.content.reportable == null || data.content.reportable == ""){
                        self.reportable = null;
                    }else{
                        self.reportable = {value: data.content.reportable, text: data.content.reportable};
                    }
                    if (data.content.status != "entry") {//Permit Status is not entry
                        self.disableFields = true;
                        self.disableUnitField = true;
                    }
                    if (data.content.status === "entry") {//Permit Status is not entry
                      //self.disablePermitField = false;
                    }
                    if (data.content.cancel_date != null) {
                        self.disableCancelDate = true;
                        self.showCancellationPrompt = true;
                    }
                    if (self.customer_id != null) {
                        self.added_customer = self.customer_id;
                        self.showCustomerField = false;
                        self.customerFound = true;
                    }
                    setTimeout(function(){
                        self.watchCall = true;
                    },500);
                    self.allowance = data.content.allowance;
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'load-permit-data')
            }
        });
    },
    onSearchCustomer(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'customer', '');
        }
    },
    BackVehiclePermitTypesList(){
        var self = this;
        setTimeout(function () {
            var path = window.location.pathname;
            var segments = path.split("/");

            if (self.$route.params.flag == 'fromAsset' || self.from == "assetView") {
                self.$router.push("/asset/view/"+self.vehicle_id.value+'?viewTab=permit');
            }else{
                self.$router.push("/vehiclepermit/list");
            }
        }, 100);
    },

    CreateVehiclePermit(flag){

        var self = this;
        var error = false;

        self.vehicle_error_msg = "";
        self.effective_date_error_msg = "";
        self.state_error_msg = "";
        self.per_number_error_msg = "";
        self.expiry_date_error_msg = "";
        self.permit_type_error_msg = "";
        self.location_error_msg = '';
        self.amount_error_msg = "";
        // self.owner_error_msg = "";
        self.added_customer_error_msg = "";
        self.common_error_msg = "";
        self.ifta_error_msg = "";
        self.nm_error_msg = "";
        self.irp_error_msg = "";
        self.pyr_error_msg = "";
        self.title_error_msg = "";
        self.cancel_date_error_msg = "";


        if(!self.unit_no || self.unit_no == ''){
            if (self.vehicle_id == null || !self.vehicle_id.value || self.vehicle_id == "") {
                self.vehicle_error_msg = "Asset Required.";
                error = true;
            }
        }

        if (self.permit_type == null || !self.permit_type.value || self.permit_type == "") {
            self.permit_type_error_msg = "Permit Type Required.";
            error = true;
        }

        if (!self.per_number || self.per_number == null || self.per_number == "") {
            self.per_number_error_msg = "Permit Number Required.";
            error = true;
        }

        if (!self.effective_date || self.effective_date == null || self.effective_date == "") {
        self.effective_date_error_msg = "Effective Date Required.";
        error = true;
        }

        if (!self.expiry_date || self.expiry_date == null || self.expiry_date == "") {
            self.expiry_date_error_msg = "Expiry Date Required.";
            error = true;
        }
        if (self.expiry_date && new Date(self.expiry_date) < new Date(self.effective_date)) {
            self.expiry_date_error_msg = "Expiry Date Should Be Greater Than Effective Date.";
            error = true;
        }
        if (self.$route.params.id > 0) {
            if (self.cancel_date != null && self.cancel_date != "") {
                if (self.effective_date != null && self.effective_date != "") {
                    if (Date.parse(self.cancel_date) < Date.parse(self.effective_date)) {
                        self.cancel_date_error_msg = "Cancel Date Should Be Greater Than Effective Date.";
                        error = true;
                    }
                }
            }
        }
        if (self.state == null || !self.state.value) {
            self.state_error_msg = "State Required.";
            error = true;
        }
        if (self.location_id == null || !self.location_id.value) {
            self.location_error_msg = "Location Required.";
            error = true;
        }
        if (String(self.amount) == "" || self.amount == 0) {
            self.amount_error_msg = "Amount Required.";
            error = true;
        }
        if (self.$route.params.id == undefined) {
            if (self.alreadyExists) {
                self.common_error_msg = "Permit Already Exists.";
                error = true;
            }
            if (self.permitNoFound) {
                self.common_error_msg = "Permit Number Already Exists.";
                error = true;
            }
        }

        if (!error) {
            if (self.$route.params.id > 0) {
                if (self.cancel_date != null && self.cancel_date != "") {
                    if (self.customer_id == null) {
                        var cancellationDetails = self.permitCancellationAmount();
                        if (!self.showCancellationPrompt) {
                            if (!self.disableCancelDate) {
                                if (cancellationDetails != null) {
                                    if (cancellationDetails.amount > 0) {
                                        //customer added along with cancel date
                                        if (self.added_customer != null) {
                                            if (!self.customerFound) {
                                                var cancellationMessage = "Remaining Permit Amount $" + cancellationDetails.amount + " for " + cancellationDetails.months +
                                                " months will be Charged to Customer.";
                                            }
                                        }else{
                                            var cancellationMessage = "Remaining Permit Amount $" + cancellationDetails.amount + " for " + cancellationDetails.months +
                                            " months will be added as an Expense for VTRL.";
                                        }
                                        if (confirm(cancellationMessage + ' Are you sure that you want to Cancel the Asset Permit?')) {
                                            self.showCancellationPrompt = true;
                                        }else{
                                            return;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createVehiclePermitBtn").val("Updating ...");
                $("#createVehiclePermitBtn").prop("disabled", true);
                $("#cancelPermitTypeBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueVehiclePermitTypeBtn").val("Saving ...");
                    $("#createVehiclePermitBtn").prop("disabled", true);
                    $("#createAndContinueVehiclePermitTypeBtn").prop("disabled", true);
                    $("#cancelPermitTypeBtn").prop("disabled",true);

                }else{

                    $("#createVehiclePermitBtn").val("Saving ...");
                    $("#createVehiclePermitBtn").prop("disabled", true);
                    $("#createAndContinueVehiclePermitTypeBtn").prop("disabled", true);
                    $("#cancelPermitTypeBtn").prop("disabled",true);
                }

            }

            var fields = $("#vehiclePermitTypeForm").serializeArray();

            var idx = fields.findIndex(obj => obj.name == 'amount');
            if (idx != -1) {
              fields.push({
                  name: "amount",
                  value: fields[idx].value.replace(/\,/g,"")
              });
              fields.splice(idx, 1);
            }

            var idx = fields.findIndex(obj => obj.name == 'ifta');
            fields.splice(idx, 1);
            var idx = fields.findIndex(obj => obj.name == 'nm');
            fields.splice(idx, 1);
            var idx = fields.findIndex(obj => obj.name == 'irp');
            fields.splice(idx, 1);
            var idx = fields.findIndex(obj => obj.name == 'pyr');
            fields.splice(idx, 1);
            var idx = fields.findIndex(obj => obj.name == 'title_fee');
            fields.splice(idx, 1);

            fields.push({name: "ifta", value: self.ifta.toString().replace(",","")});
            fields.push({name: "nm", value: self.nm.toString().replace(",","")});
            fields.push({name: "irp", value: self.irp.toString().replace(",","")});
            fields.push({name: "pyr", value: self.pyr.toString().replace(",","")});
            fields.push({name: "title_fee", value: self.title_fee.toString().replace(",","")});

            fields.push({name: "vehicle_id", value: self.vehicle_id.value});
            fields.push({name: "state_id", value: self.state.value});
            fields.push({name: "location_id", value: self.location_id.value});
            // fields.push({name: "customer_id", value: self.customer_id.value});
            fields.push({name: "permit_type", value: self.permit_type.value});
            fields.push({name: "Permit", value: self.per_number});
            fields.push({name:"description",value:self.description});

            if(self.licence_type == null){
                fields.push({name: "licence_type", value: ""});
            }else{
                fields.push({name: "licence_type", value: self.licence_type.value});
            }

            if(self.reportable == null){
                fields.push({name: "reportable", value: ""});
            }else{
                fields.push({name: "reportable", value: self.reportable.value});
            }

            fields.push({name: "id", value: segments[3]});
            // if (self.owner.value.toLowerCase() == "customer" || self.customerFound) {
            if (self.customerFound) {
                fields.push({name: "customer_id", value: self.added_customer.value});
            }else{
                fields.push({name: "customer_id", value: ""});
            }
            if (self.$route.params.id > 0) {
                fields.push({name: "effective_date", value: self.effective_date});
                fields.push({name: "expiry_date", value: self.expiry_date});
                fields.push({name: "amount", value: self.amount.replace(/\,/g,"")});
                // if (self.disableCancelDate) {
                    fields.push({name: "cancel_date", value: self.cancel_date});
                // }
                if (self.showCustomerField) {
                    if (!self.customerFound) {
                        if (self.added_customer != null) {
                            fields.push({name: "customer_id", value: self.added_customer.value});
                            fields.push({name: "customer_added", value: 1});
                        }else{
                            fields.push({name: "customer_id", value: ""});
                            fields.push({name: "customer_added", value: 0});
                        }
                    }
                }
            }

            $.ajax({
                url: process.env.ROOT_API + "/vehiclepermit/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createVehiclePermitBtn").val("Update");
                        $("#createVehiclePermitBtn").prop("disabled", false);
                        $("#cancelPermitTypeBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueVehiclePermitTypeBtn").val("Save and Continue");
                            $("#createVehiclePermitBtn").prop("disabled", false);
                            $("#createAndContinueVehiclePermitTypeBtn").prop("disabled", false);
                            $("#cancelPermitTypeBtn").prop("disabled",false);

                        }else{

                            $("#createVehiclePermitBtn").val("Save");
                            $("#createVehiclePermitBtn").prop("disabled", false);
                            $("#createAndContinueVehiclePermitTypeBtn").prop("disabled", false);
                            $("#cancelPermitTypeBtn").prop("disabled",false);

                        }
                    }
                    if (data.code == 200) {

                        if (flag == "Save and Continue") {

                            $("#vehiclePermitTypeForm").trigger("reset");
                            self.name ="";
                            self.state = "";
                            self.description = "";
                            self.vehicle_id = null;
                            self.permit_type = null;
                            self.per_number = '';
                            self.location_id = null;
                            self.amount = 0;
                            self.license_type = null;
                            self.reportable = null;
                            self.ifta = "";
                            self.nm = "";
                            self.irp = "";
                            self.pyr = "";
                            self.title_fee = "";
                            // self.owner = null;


                        }else{
                            if(self.fromUrl != ""){
                              var url = self.fromUrl+'?viewTab=permit';
                              self.redirectPageUrl(url);
                            }else if(self.from == "assetView"){
                              self.$router.push("/asset/view/"+self.vehicle_id.value+'?viewTab=permit');
                            }else{
                              self.$router.push("/vehiclepermit/list");
                            }
                            // self.$router.push("/asset/view/"+self.vehicle_id.value);

                        }

                    } else if(data.code == 201){

                        $("#errorMsg").html(data.message);
                        $(".alert-warning").toggleClass("show");
                        setTimeout(function () {
                            $(".alert-warning").removeClass("show");
                            $(".alert-warning").addClass("hide");
                        }, 10000);

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createVehiclePermitBtn").val("Update");
                        $("#createVehiclePermitBtn").prop("disabled", false);
                        $("#cancelPermitTypeBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#vehiclePermitTypeForm").trigger("reset");


                            $("#createAndContinueVehiclePermitTypeBtn").val("Save and Continue");
                            $("#createVehiclePermitBtn").prop("disabled", false);
                            $("#createAndContinueVehiclePermitTypeBtn").prop("disabled", false);
                            $("#cancelPermitTypeBtn").prop("disabled",false);

                        }else{

                            $("#createVehiclePermitBtn").val("Save");
                            $("#createVehiclePermitBtn").prop("disabled", false);
                            $("#createAndContinueVehiclePermitTypeBtn").prop("disabled", false);
                            $("#cancelPermitTypeBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'create-permit-data')
                }
            });

        }else{
            self.errorValidationFocus();
      }

    },
    formatString(data) {
        var self = this;
        var value = data.replace(/_/g, " ");
        var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
            return letter.toUpperCase();
        });
        return upp;
    },
    permitCancellationAmount() {
        var self = this;
        if (self.effective_date != null && self.effective_date != "" && self.expiry_date != null && self.expiry_date != "") {
            if (self.cancel_date != null && self.cancel_date != "") {
                if (String(self.amount) != "") {
                    var totalMonths = self.getMonthDiff(self.effective_date,self.expiry_date);
                    var remainingMonths = self.getMonthDiff(self.cancel_date,self.expiry_date);
                    remainingMonths = remainingMonths - 1; //skip current month
                    var cancelledAmount = (self.amount.replace(/\,/g,"") / totalMonths) * remainingMonths;
                    cancelledAmount = cancelledAmount.toFixed(2);

                    return {
                        months:remainingMonths,
                        amount:cancelledAmount
                    };
                }
            }
        }
    },
    getMonthDiff(dateFrom,dateTo) {
        var fromDate = new Date(dateFrom);
        var toDate = new Date(dateTo);
        var monthFrom = fromDate.getMonth() + 1;
        var monthTo = toDate.getMonth() + 1;
        var yearFrom = fromDate.getFullYear();
        var yearTo = toDate.getFullYear();

        if (yearFrom == yearTo) {
            return (parseInt(monthTo)-parseInt(monthFrom))+1;
        } else {
            return (12-parseInt(monthFrom))+1+parseInt(monthTo);
        }

    },
    validateAmount: function (evt) {

        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        //alert(charCode)
        if ((charCode > 31 && charCode != 44 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf(
                '.') != -1)) {
            evt.preventDefault();
        } else {
            return true;
        }
    },
    checkPermitNumber() {
        var self = this;
        var error = false;
        self.per_number_error_msg = "";
        self.vehicle_error_msg = "";

        if (self.$route.params.id == undefined) {
            if (!self.per_number || self.per_number == null || self.per_number == "") {
                self.per_number_error_msg = "Permit Number Required.";
                error = true;
            }
            if (self.vehicle_id == null || !self.vehicle_id.value || self.vehicle_id == "") {
                self.vehicle_error_msg = "Asset Required.";
                error = true;
            }

            if (!error) {
                $.ajax({
                    url: process.env.ROOT_API + "/permit-number/check",
                    type: "POST",
                    headers: this.ajxHeaders,
                    data:{
                        permit_no:self.per_number,
                        vehicle_id:self.vehicle_id.value
                    },
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        console.log(data);

                        if (data.status == "success") {
                            if (data.content != "" && data.content == "exists") {
                                self.common_error_msg = "Permit Number Already Exists.";
                                self.permitNoFound = true;
                            }else{
                                self.common_error_msg = "";
                                self.permitNoFound = false;
                                self.permitNoMessage = "";
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'check-permit-number')
                    }
                });
            }
        }

    },
    getPermitDetails() {
        var self = this;
        var error = false;
        self.per_number_error_msg = "";
        self.effective_date_error_msg = "";
        self.expiry_date_error_msg = "";
        self.vehicle_error_msg = "";
        self.common_error_msg = "";

        if (self.$route.params.id == undefined) {

            if (self.vehicle_id == null || !self.vehicle_id.value || self.vehicle_id == "") {
                self.vehicle_error_msg = "Asset Required.";
                error = true;
            }

            if (!self.effective_date || self.effective_date == null || self.effective_date == "") {
                self.effective_date_error_msg = "Effective Date Required.";
                error = true;
            }

            if (!self.expiry_date || self.expiry_date == null || self.expiry_date == "") {
                self.expiry_date_error_msg = "Expiry Date Required.";
                error = true;
            }

            if (!error) {

                var vehicleId = "";
                if (self.vehicle_id != null && self.vehicle_id != "") {
                    vehicleId = self.vehicle_id.value;
                }

                var fields = {
                    permit_no:self.per_number,
                    effective_date:self.effective_date,
                    expiry_date:self.expiry_date,
                    vehicle_id:vehicleId
                }
                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/permit-create/details",
                    type: "POST",
                    headers: this.ajxHeaders,
                    data: fields,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        console.log(data);

                        if (data.status == "success" && data.content != "") {
                            self.detailFound = true;

                            self.permitNumber = data.content.permit_number;
                            self.effectiveDate = data.content.effective_date;
                            self.expiryDate = data.content.expiry_date;
                            self.permitTypeDesc = data.content.permitTypeDes;

                            /*if (data.content.permit_num_found == 1) {
                                self.permitNoFound = true;
                            }else{
                                self.permitNoFound = false;
                            }*/

                            if (data.content.permit_msg != null && data.content.permit_msg != "") {
                                self.permitMessage = data.content.permit_msg;
                            }else{
                                self.permitMessage = "";
                            }

                            /*if (data.content.permit_no_msg != null && data.content.permit_no_msg != "") {
                                self.permitNoMessage = data.content.permit_no_msg;
                            }else{
                                self.permitNoMessage = "";
                            }*/
                            self.permitReference = data.content.reference;
                            if (data.content.already_exists == 1) {
                                self.alreadyExists = true;
                            }else{
                                self.alreadyExists = false;
                            }

                        }else{
                            self.detailFound = false;
                            // self.permitNoFound = false;
                            self.alreadyExists = false;
                            self.permitMessage = "";
                            self.permitNoMessage = "";
                            self.permitReference = "";
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'create-permit-data')
                    }
                });

            }
        }

    },
    calculatePermitAmount(event) {
        var self = this;
        var amount = 0;

        if (self.ifta != "") {
            amount +=  Number(self.ifta.toString().replace(",",""));
        }

        if (self.nm != "") {
            amount +=  Number(self.nm.toString().replace(",",""));
        }

        if (self.irp != "") {
            amount +=  Number(self.irp.toString().replace(",",""));
        }

        if (self.pyr != "") {
            amount +=  Number(self.pyr.toString().replace(",",""));
        }

        if (self.title_fee != "") {
            amount +=  Number(self.title_fee.toString().replace(",",""));
        }
        self.amount = self.amountFormat(amount);
    },
    inputUpperCase(e) {
        var charInput = e.keyCode;
        if((charInput >= 97) && (charInput <= 122)) { // lowercase
            if(!e.ctrlKey && !e.metaKey && !e.altKey) { // no modifier key
                var newChar = charInput - 32;
                var start = e.target.selectionStart;
                var end = e.target.selectionEnd;
                e.target.value = e.target.value.substring(0, start) + String.fromCharCode(newChar) + e.target.value.substring(end);
                e.target.setSelectionRange(start+1, start+1);
                e.preventDefault();
            }
        }
    },
    // onOwnerSelect(evt) {
    //     var self = this;
    //     self.owner_error_msg = "";
    //     if (self.owner != null && self.owner != "") {
    //         self.added_customer = null;
    //         self.showCustomerField = false;
    //         if (self.owner.value.toLowerCase() == "customer") {
    //             self.showCustomerField = true;
    //         }
    //     }
    // }
    fetchUnitPermit(){
        var self = this;
        if (self.vehicle_id != null && self.vehicle_id != "" && self.vehicle_id.value) {
            var fields = {
                vehicle_id:self.vehicle_id.value
            }
            self.loading = true;

            $.ajax({
                url: process.env.ROOT_API + "/unit-permit/fetch",
                type: "POST",
                headers: this.ajxHeaders,
                data: fields,
                dataType: "json",
                success: function (data) {
                    self.loading = false;

                    if (data.status == "success" && data.content != "") {
                        self.per_number = data.content.permit_number;
                        self.effective_date = data.content.effective_date;
                        self.expiry_date = data.content.expiry_date;
                        self.unitPermitFound = true;
                        //self.disablePermitField = false;
                    }else{
                        self.disablePermitField = false;
                        self.unitPermitFound = false;
                        self.per_number = "";
                        self.effective_date = "";
                        self.expiry_date = "";
                        self.per_number_error_msg = "Permit Number Required.";
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'create-permit-data')
                }
            });
        }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/VehiclePermitCreate.vue